import React, { FC, useState } from 'react';


type Props = {
    className?: string;
    type?: 'button' | 'submit' | 'reset';
    onClick?(): void;
    width?: string;
    height?: string;
    backgroundColor?: string;
    color?: string;
};


export const Button: FC<Props> = ({ className, type, onClick, children, width, height, backgroundColor, color }) => {
    const [loading, setLoading] = useState(false);

    async function handleOnClick() {
        if (onClick) {
            if (loading) return;
            setLoading(!loading);
            onClick();
            setLoading(true);
        };
    };

    return (
        <button
            className={className}
            type={type ?? "button"}
            onClick={handleOnClick}
        >
            {children}

            <style jsx>{`
                button {
                    cursor: pointer;
                    width: ${width ?? "120px"};
                    height: ${height ?? "40px"};
                    font-size: 14px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: ${backgroundColor ?? "#fd6c07"};
                    border: none;
                    color: ${color ?? "#fff"};
                    border-radius: 24px;
                    outline: none;
                }
            `}</style>
        </button>
    );
};
